module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGNobon9TwlmGDVg1IBRA4aLAQC+OGMfs4k49wAAAABJRU5ErkJggg=="